import React from "react";
import { IconProps, iconPropTypes } from "./IconProps";

const ArrowLeftIcon: React.FC<IconProps> = ({
  fill = "",
  width = 32,
  height = 32,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M28 15.9999C28 16.2652 27.8946 16.5195 27.7071 16.7071C27.5196 16.8946 27.2652 16.9999 27 16.9999H7.41374L14.7075 24.2924C14.8004 24.3854 14.8741 24.4957 14.9244 24.6171C14.9747 24.7384 15.0005 24.8686 15.0005 24.9999C15.0005 25.1313 14.9747 25.2614 14.9244 25.3828C14.8741 25.5042 14.8004 25.6145 14.7075 25.7074C14.6146 25.8004 14.5043 25.8741 14.3829 25.9243C14.2615 25.9746 14.1314 26.0005 14 26.0005C13.8686 26.0005 13.7385 25.9746 13.6171 25.9243C13.4957 25.8741 13.3854 25.8004 13.2925 25.7074L4.29249 16.7074C4.19952 16.6146 4.12576 16.5043 4.07543 16.3829C4.02511 16.2615 3.99921 16.1314 3.99921 15.9999C3.99921 15.8685 4.02511 15.7384 4.07543 15.617C4.12576 15.4956 4.19952 15.3853 4.29249 15.2924L13.2925 6.29245C13.4801 6.1048 13.7346 5.99939 14 5.99939C14.2654 5.99939 14.5199 6.1048 14.7075 6.29245C14.8951 6.48009 15.0005 6.73458 15.0005 6.99995C15.0005 7.26531 14.8951 7.5198 14.7075 7.70745L7.41374 14.9999H27C27.2652 14.9999 27.5196 15.1053 27.7071 15.2928C27.8946 15.4804 28 15.7347 28 15.9999Z" />
  </svg>
);

ArrowLeftIcon.propTypes = iconPropTypes;

export default ArrowLeftIcon;
